var _defs, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoModuleFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 600,
    height: 321,
    viewBox: "0 0 600 321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ojpq2h02va",
    x1: 0.5,
    y1: 0.014,
    x2: 0.5,
    y2: 0.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178650"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178620",
    transform: "translate(-419 -343)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 464",
    cx: 300,
    cy: 90,
    rx: 300,
    ry: 90,
    transform: "translate(419 484)",
    style: {
      fill: "url(#ojpq2h02va)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178595"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178594"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178576"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178573"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29445",
    d: "M499.375 699.157v149.986L388.4 836.824a12.317 12.317 0 1 1-24.635 0V717.393L382 699.157z",
    transform: "translate(287.242 -307.15)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29446",
    d: "M494.382 845.156a.984.984 0 0 1-.111-.006l-109.9-12.2a13.324 13.324 0 0 1-26.6-1.12V712.4a1.008 1.008 0 0 1 .295-.712l18.234-18.236a1.007 1.007 0 0 1 .712-.295h117.37a1.007 1.007 0 0 1 1.007 1.007v149.985a1.007 1.007 0 0 1-1.007 1.007zm-134.6-132.339V831.83a11.31 11.31 0 1 0 22.621 0 1.007 1.007 0 0 1 1.118-1l109.857 12.2V695.171H377.424z",
    transform: "translate(292.235 -302.157)",
    style: {
      fill: "#e6e6ea"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178574"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29447",
    d: "M560.447 1531.773H437.154a12.319 12.319 0 0 0 12.318-12.318z",
    transform: "translate(226.17 -989.781)",
    style: {
      fill: "#e6e6ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29448",
    d: "M555.454 1527.786H432.161a1.007 1.007 0 1 1 0-2.014 11.324 11.324 0 0 0 11.311-11.311 1.007 1.007 0 0 1 1.118-1l110.975 12.318a1.007 1.007 0 0 1-.111 2.008zm-116.254-2.014h98.057l-91.816-10.192a13.338 13.338 0 0 1-6.241 10.192z",
    transform: "translate(231.163 -984.786)",
    style: {
      fill: "#e6e6ea"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178575"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29449",
    d: "M382 699.157v18.237h-18.235z",
    transform: "translate(287.242 -307.15)",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29450",
    d: "M377.006 713.407h-18.235a1.007 1.007 0 0 1-.712-1.719l18.235-18.236a1.007 1.007 0 0 1 1.719.712V712.4a1.007 1.007 0 0 1-1.007 1.007zm-15.8-2.014H376v-14.8z",
    transform: "translate(292.236 -302.157)",
    style: {
      fill: "#e6e6ea"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178585"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178577"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146433",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h24.638v2.014H0z",
    transform: "translate(664.857 423.104)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178578"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146434",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h106.566v2.014H0z",
    transform: "translate(664.857 436.591)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178579"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146435",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h106.566v2.014H0z",
    transform: "translate(664.857 450.078)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178580"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146436",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h106.566v2.014H0z",
    transform: "translate(664.857 463.566)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178581"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146437",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h106.566v2.014H0z",
    transform: "translate(664.857 477.053)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178582"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146438",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h106.566v2.014H0z",
    transform: "translate(664.857 490.54)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178583"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146439",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h106.566v2.014H0z",
    transform: "translate(664.857 504.027)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178584"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 146440",
    style: {
      fill: "#e6e6ea"
    },
    d: "M0 0h61.12v2.014H0z",
    transform: "translate(664.857 517.515)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178593"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178586",
    transform: "translate(731 375)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1789",
    cx: 39.393,
    cy: 39.393,
    r: 39.393,
    transform: "translate(.607 .607)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29451",
    d: "M687.879 682.894a39.876 39.876 0 1 1 15.052-2.929 39.869 39.869 0 0 1-15.052 2.929zm0-78.768a38.768 38.768 0 1 0 27.426 11.342 38.665 38.665 0 0 0-27.426-11.342z",
    transform: "translate(-647.879 -602.894)",
    style: {
      fill: "#e6e6ea"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29452",
    d: "M800.92 710.111a30.18 30.18 0 0 0-42.607 42.607 30.18 30.18 0 1 1 42.607-42.607z",
    transform: "translate(-6.976 -315.351)",
    style: {
      fill: "#f5f5f7",
      opacity: 0.997
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178587"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29453",
    d: "M772.886 756.5a30.868 30.868 0 1 1 30.394-36.3l.106.6-1.195.212-.106-.6a29.657 29.657 0 1 0 .009 10.4l.105-.6 1.2.21-.105.6a30.88 30.88 0 0 1-30.4 25.487z",
    transform: "translate(-1.435 -310.663)",
    style: {
      fill: "#e6e6ea"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178609",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178605"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178602"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29460",
    d: "M1049.277 327.486a1.542 1.542 0 0 1-1.123-.482l-24.2-25.507a1.547 1.547 0 0 1 2.244-2.13l24.2 25.507a1.547 1.547 0 0 1-1.122 2.612z",
    transform: "translate(-266.175 101.814)",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178603"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29461",
    d: "M1067.912 345.427a.852.852 0 0 1-.62-.266l-24.2-25.507a.854.854 0 0 1 1.239-1.175l24.2 25.507a.854.854 0 0 1-.619 1.441z",
    transform: "translate(-284.809 83.18)",
    style: {
      fill: "#949494"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178608"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178602"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29460",
    d: "M1025.073 327.486a1.542 1.542 0 0 0 1.127-.486l24.2-25.507a1.547 1.547 0 1 0-2.244-2.13l-24.2 25.507a1.547 1.547 0 0 0 1.122 2.612z",
    transform: "translate(-266.175 101.814)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 178603"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29461",
    d: "M1043.708 345.427a.852.852 0 0 0 .62-.266l24.2-25.507a.854.854 0 0 0-1.239-1.175l-24.2 25.507a.854.854 0 0 0 .619 1.441z",
    transform: "translate(-284.809 83.18)",
    style: {
      fill: "#949494"
    }
  }))))))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: "50%",
    y: "70%",
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 16,
    fill: "#555",
    opacity: 0.7
  }, "\n            Module Not Found\n        "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoModuleFound);
export default __webpack_public_path__ + "static/media/NoModuleFound.1a8d2967c940969da7ff4a6a0fc44633.svg";
export { ForwardRef as ReactComponent };